module.exports = __webpack_public_path__ + "media/images/bg-suggest-d8c6e46101e3d03fcb2823bd59a33f54.png";